import { BoxProps, ColorOptions, TextNewProps } from '@jfs/ui-new'
import { Colors } from '../../../../util/util'

export const styles = {
  addReportButton: {
    borderRadius: 8,
    ph: 16,
    pv: 8,
    mt: 40,
    w: 176,
    h: 40,
    backgroundColor: Colors.REPORT_PRIMARY,
    underlayColor: 'BLUE',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
  } as BoxProps,
  titleText: {
    fontSize: 20,
    fontFamily: 'jiotype-bold',
    textAlign: 'center',
    color: 'BLACK_21' as ColorOptions,
  } as TextNewProps,
  subTitleText: {
    fontSize: 16,
    textAlign: 'center',
    color: Colors.SLATE as ColorOptions,
  } as TextNewProps,
  container: {
    flex: 1,
    justify: 'center',
    bg: 'LIGHTEST_GREY_2',
  } as BoxProps,
  subContainer: {
    ph: '30%',
    pt: 20,
  } as BoxProps,
  iconContainer: {
    alignSelf: 'center',
    mb: 50,
  } as BoxProps,
}
